<template>
  <div>
    <GNavBar></GNavBar>
    <h1 class="mt-5 pt-5">CourseDev tools</h1>
    <hr />
    <div v-if="this.$route.params.tool === 'create-dev-site'">
      <b-row align-h="center">
        <b-col md="8">
          <b-alert variant="warning" show
            >This tool is limited to IPA projects; do not use this for creating
            non-CAA/IPA dev sites. Instead, use the
            <a
              class="alert-link"
              href="https://docs.google.com/spreadsheets/d/1CL2pXcIYO9E0-_RFaGdjj-VuEEUjWUThv6GVWPin9H8/edit?usp=sharing"
              >Request for Dev Site form</a
            >
            on the google drive.
          </b-alert>
          <h2>Create dev sites</h2>
          <p>
            Below are all of the projects that are currently require a dev site.
            After entering the new dev site's details, you can enter the data by
            pressing submit.
          </p>
          <p>This will:</p>
          <ul>
            <li>Save the dev site's information to the database</li>
            <li>Add a note to the interaction log</li>
            <li>Link the dev site to the project's record</li>
          </ul>
          <p>
            Number of dev sites to be created:
            <strong>{{ sites.length }}</strong>
          </p>
        </b-col>
        <b-col md="10">
          <GCreateDevSites />
        </b-col>
      </b-row>
    </div>
    <div v-if="this.$route.params.tool === 'ofdit-approval'">
      <b-row align-h="center">
        <b-col md="8">
          <h2>OFDIT approval</h2>
          <p>
            Below are all of the requests that are currently require OFDIT
            approval before having a request form created. Please review the
            request, enter your notes in the OFDIT approval textbox, use the
            dropdown to approval or reject a request, and press submit.
          </p>
          <p>For approved projects this will:</p>
          <ul>
            <li>Change the status of the project to <em>OFDIT approval</em></li>
            <li>Add a note to the interaction log</li>
          </ul>
          <p>
            Number of requests to be reviewed:
            <strong>{{ requests.length }}</strong>
          </p>
        </b-col>
        <b-col md="10">
          <GOfditApproval />
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
  import GCreateDevSites from '@/components/GCreateDevSites'
  import GOfditApproval from '@/components/GOfditApproval.vue'
  import GNavBar from '@/components/GNavBar.vue'

  export default {
    name: 'ProjectTools',
    components: {
      GCreateDevSites,
      GOfditApproval,
      GNavBar
    },
    data() {
      return {}
    },
    computed: {
      sites() {
        return this.$store.state.courseDev.devSitesToBeCreated
      },
      requests() {
        return this.$store.getters.dataImportedProjects
      }
    }
  }
</script>
